// extracted by mini-css-extract-plugin
export default {"cities":"Cities_cities__6DnPl","wrapper":"Cities_wrapper__-bbSE","cities_list":"Cities_cities_list__SQQJt","menu_active":"Cities_menu_active__KlJmK"};